import '@unocss/reset/tailwind.css'
import 'virtual:uno.css'
import './styles/main.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import globalCompnents from '@/components'
import App from './App.vue'
import globalDirectives from './directives'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(globalCompnents)
app.use(globalDirectives)

app.mount('#app')
